import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import Login from '@pages/auth/login/Login';
import ForgotPassword from '@pages/auth/forgotPassword/ForgotPassword';
import ResetPassword from '@pages/auth/resetPassword/ResetPassword';

const AuthRoutes: React.FC = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={`${path}/login`}>
                <Login />
            </Route>
            <Route exact path={`${path}/forgot-password`}>
                <ForgotPassword />
            </Route>
            <Route exact path={`${path}/reset-password`}>
                <ResetPassword />
            </Route>
        </Switch>
    );
};

export default AuthRoutes;
